/**
 * Created by FangShenglong at 2018/12/07
 * Description 该文件中主要用于定义工程中的工具函数
 */
import CryptoJS from 'crypto-js'
import {
  Base64
} from 'js-base64';
import dayjs from 'dayjs'
import config from '@src/common/config'
import log from '@src/common/utils/log'
/*
 *@Description: 系统工具库加载入口
 *@Author: zhengff
 *@Date: 2019-04-21 22:55:47
 */
import BASE from './base'
import CHCHE from './cache'
import DATE from './date'
import CRYPTO from './crypto'
import LOG from './log'
import VALIDATE from './validate'
import DIC from './dic'
import DATA from './data'
import BUS from './bus'

// 单对象暴露
export const Base = BASE
export const Cache = CHCHE
export const Dates = DATE
export const Validate = VALIDATE
export const Log = LOG
export const Dic = DIC
export const Data = DATA
export const Crypto = CRYPTO

export const Bus = BUS

const utils = {
  Base: BASE,
  Cache: CHCHE,
  Dates: DATE,
  Validate: VALIDATE,
  Log: LOG,
  Dic: DIC,
  Data: DATA,
  Bus: BUS,
  Crypto: CRYPTO,
  /**
   * encryptAES AES加密字符串
   * @param {String} str 待加密的字符串
   * @param {String} key AES加密使用的秘钥
   * @returns {String} 加密后的字符串
   */
  encryptAES: (str, key) => {
    str = str || '';
    key = key || '';
    let content = CryptoJS.enc.Utf8.parse(str);
    let encry = CryptoJS.AES.encrypt(content, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encry.ciphertext.toString();
  },

  /**
   * appendZero 字符串补零操作
   * @param {String} str 待补零的字符串
   * @param {number} length 补零后的字符串长度
   * @param {boolean} left 补零方式：true：左补零，false：右补零
   * @param {boolean} subFlag 是否需要截取字符串，如字符串长度超过“补零后的字符串长度”，则将原始字符串进行截取至“补零后的字符串长度”
   * @returns {String} 补零后的结果字符串
   */
  appendZero: (str, length, left, subFlag) => {
    if (!length || length <= 0) {
      return str;
    }
    if (!str || !(str + '').trim().length) {
      str = '';
    }
    str += '';
    let strLength = str.length;
    while (strLength < length) {
      if (left) {
        str = '0' + str;
      } else {
        str += '0';
      }
      strLength++
    }
    if (subFlag) {
      str = str.substr(0, length);
    }
    return str;
  },

  /**
   * createUUID 根据UUID key生成UUID
   */
  createUUID: () => {
    let s = [];
    let hexDigits = config.UUID_KEY;
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    let uuid = s.join('');
    return uuid;
  },

  /**
   * getDateStr 根据日期获取时间字符串
   * @param {Date} date 待转换的时间，不传则取当前时间
   * @param {String} formatStr 转换后的格式，默认为'YYYY-MM-DD HH:mm:ss'
   * @returns {String} 日期转换后的结果字符串，如:2018-12-12 09:57:18
   */
  getDateStr: (date, formatStr) => {
    if (!date) {
      date = new Date();
    }
    formatStr = formatStr || 'YYYY-MM-DD HH:mm:ss'
    return dayjs(date).format(formatStr);
  },

  /**
   * isIE 判断当前浏览器是否是IE浏览器
   * @returns {Boolean} 如果当前浏览器为IE浏览器，则返回true，否则返回false
   */
  isIE: () => {
    return (window.navigator.userAgent.indexOf('MSIE') !== -1);
  },

  /**
   * encode 使用Base64对字符串进行混淆
   * @param {String} input 待混淆的字符串
   * @returns {String} 使用Base64混淆后的字符串
   */
  encode: (input) => {
    if (input === null || input === undefined) {
      return null;
    }
    input += '';
    if (input.trim() === '') {
      return null;
    }
    return Base64.encode(input);
  },

  /**
   * decode 解析Base64混淆过的字符串
   * @param {String} input 待解析的字符串
   * @returns {String} 解析后的字符串
   */
  decode: (input) => {
    input += '';
    let result = null;
    try {
      result = Base64.decode(input);
    } catch (e) {
      log.error('字符串解码失败，待解码的字符串为：', input, '；错误信息为：', e);
    }
    return result;
  },

  /**
   * parseObj 将JSON字符串转换成JSON对象
   * @param {String} input 待转换的字符串
   * @returns {Object} 转换后的对象
   */
  parseObj: (input) => {
    input += '';
    let result = null;
    try {
      result = JSON.parse(input);
    } catch (e) {
      log.error('字符串转换JSON对象失败，待转换的字符串为：', input, '；错误信息为：', e);
    }
    return result;
  },

  /**
   * stringifyParams 将参数对象转换为字符串
   * @param {Object} input 待转换的字符串
   * @returns {Object} 转换后的对象
   */
  stringifyParams: (input) => {
    input = input || {};
    input.timestamp = new Date().getTime();
    let result = null;
    try {
      result = JSON.stringify(input);
    } catch (e) {
      log.error('参数对象转换字符串失败，待转换的参数对象为：', input, '；错误信息为：', e);
    }
    return result;
  },

  /**
   * buildQueryParams 构造查询路由query参数对象
   * @param {Object} params 待传递的参数对象
   * @returns {Object} 构造后的路由参数对象
   */
  buildQueryParams: (params) => {
    params = params || {};
    return {
      params: utils.encode(utils.stringifyParams(params))
    };
  },

  /**
   * parseQueryParams 解析查询路由query参数对象
   * @param {Object} params 待解析的参数对象
   * @returns {Object} 解析后的路由参数对象
   */
  parseQueryParams: (params) => {
    if (!params || !params.params) {
      return {};
    }
    return utils.parseObj(utils.decode(params.params));
  },

  /**
   * unRepeatArray 对象数组去重操作
   * @param {Array} resource 待去重的对象数组
   * @param {String} key 去重依据字段
   * @returns {Object} 转换后的对象
   */
  unRepeatArray: (resource, key) => {
    if (!resource || !resource.length || !key || !key.length) {
      return resource;
    }
    let tempData = [];
    let tempObj = {};
    resource.forEach((item) => {
      if (!tempObj[item[key]]) {
        tempData.push(item);
        tempObj[item[key]] = true;
      }
    })
    return tempData;
  },

  /**
   * getOffsetByBody 获取当前元素相对于页面BODY元素的位置，左边和顶部
   * @param {Document} el 待获取位置的元素对象，为HTML DOM对象
   * @returns {Object} {offsetLeft: 左边相对于BODY的位置, offsetTop: 顶部相对于BODY元素的位置}
   */
  getOffsetByBody(el) {
    let offsetLeft = 0;
    let offsetTop = 0;
    let offsetWidth = el.offsetWidth;
    let offsetHeight = el.offsetHeight;
    while (el && el.tagName !== 'BODY') {
      offsetLeft += el.offsetLeft
      offsetTop += el.offsetTop
      el = el.offsetParent
    }
    return {
      offsetLeft: offsetLeft,
      offsetTop: offsetTop,
      offsetWidth: offsetWidth,
      offsetHeight: offsetHeight
    }
  },

  /**
   * getStyleMap 根据样式字符串获取样式键值对，为兼容IE浏览器设置元素的样式，需要将样式字符串封装为样式键值对对象，用于设置元素样式属性
   * @param {String} styleStr 待设置的样式字符串
   * @returns {Object} 封装后的样式键值对对象，key：style样式名称，value：style样式值
   */
  getStyleMap(styleStr) {
    let result = [];
    // 样式字符串存在才封装样式键值对
    if (styleStr && styleStr.length && styleStr.indexOf(':') !== -1) {
      // 将样式字符串根据“;”进行分割
      let temp = styleStr.split(';');
      temp.forEach((item) => {
        if (item && item.trim().length && item.trim().indexOf(':') !== -1) {
          // 去两边空格
          item = item.trim();
          // 根据“:”获取键值信息
          let key = item.split(':')[0];
          let value = item.split(':')[1];
          // 键值都存在继续封装
          if (key && key.trim().length && value && value.trim().length) {
            // 如果key包含“-”，则需要将key封装为驼峰命名的方式
            if (key.indexOf('-') !== -1) {
              let newKey = '';
              let tempKey = key.split('-');
              tempKey.forEach((keyItem, index) => {
                keyItem = keyItem.trim();
                newKey += (index === 0) ? keyItem : (keyItem.charAt(0).toUpperCase() + keyItem.substring(1, keyItem.length));
              });
              key = newKey;
            }
            result.push({
              key: key.trim(),
              value: value.trim()
            });
          }
        }
      })
    }
    return result;
  },

  /**
   * deepObjectMerge 深度合并对象，如a对象中存在的值，b对象中不存在，则继续保留a对象的值
   * @param {Object} a 需合并的基础对象
   * @param {Object} b 需合并至基础对象的对象
   * @returns {Object} 合并后的对象
   */
  deepObjectMerge(a, b) {
    for (let key in b) {
      a[key] = a[key] && typeof a[key] === 'object' ? utils.deepObjectMerge(a[key], b[key]) : a[key] = b[key];
    }
    return a;
  },
  /**
   * esc监听全屏
   */
  listenFullScreen: (flag, callback) => {
    if (flag === 'add') {
      document.addEventListener('fullscreenchange', callback);
      document.addEventListener('mozfullscreenchange', callback);
      document.addEventListener('webkitfullscreenchange', callback);
      document.addEventListener('msfullscreenchange', callback);
      document.onmsfullscreenchange = callback;
    } else {
      document.removeEventListener('fullscreenchange', callback);
      document.removeEventListener('mozfullscreenchange', callback);
      document.removeEventListener('webkitfullscreenchange', callback);
      document.removeEventListener('msfullscreenchange', callback);
      document.onmsfullscreenchange = null;
    }
  },

  /**
   * 浏览器判断是否全屏
   */
  isFullScreen: () => {
    return (
      // 默认判断浏览器是否全屏
      document.isFullScreen ||
      // 未知，原应该是判断Firefox浏览器，但是该属性未生效
      document.mozIsFullScreen ||
      // 判断Chrome浏览器是否全屏
      document.webkitIsFullScreen ||
      // 判断IE浏览器是否全屏
      document.msFullscreenElement ||
      // 判断Firefox浏览器是否全屏
      document.fullscreenElement
    )
  },

  /**
   * 浏览器全屏
   */
  reqFullScreen: () => {
    if (document.documentElement.requestFullScreen) {
      // 默认设置浏览器全屏
      document.documentElement.requestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      // 设置Chrome浏览器全屏
      document.documentElement.webkitRequestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      // 设置Firefox浏览器全屏
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.msRequestFullscreen) {
      // 设置IE浏览器全屏
      document.documentElement.msRequestFullscreen();
    }
  },

  /**
   * 浏览器退出全屏
   */
  exitFullScreen: () => {
    if (document.documentElement.requestFullScreen) {
      // 默认退出浏览器全屏
      document.exitFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      // 退出Chrome浏览器全屏
      document.webkitCancelFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      // 退出Firefox浏览器全屏
      document.mozCancelFullScreen();
    } else if (document.documentElement.msRequestFullscreen) {
      // 退出IE浏览器全屏
      document.msExitFullscreen();
    }
  },
  /**
   * 工单对象和info的转换，对象属性和以‘;’保存的字符串
   */
  setFieldData(newObj, target) {
    // 排除info以外的属性
    let list = [];
    let local = {
      ...newObj
    };
    //获取所有保存的info值，切记切记要保证跟本地数据顺序一致
    list = target.info.split(';')
    let keys = Object.keys(local);
    // 去掉所有info之外的属性
    keys.splice(0, 3);
    for (let index = 0; index < keys.length; index++) {
      const element = keys[index];
      if ((parseInt(list[index]) || parseInt(list[index]) === 0) && 'number' === typeof local[element]) {
        local[element] = parseInt(list[index]);
      } else {
        local[element] = list[index];
      }
    }
    local.type = Number(local.type)
    local.fieldName = target.fieldName
    local.fieldValue = local.value
    if (local.type === 5 && local.selectType === 2) {
      local.fieldValue = local.fieldValue || []
    }
    if (local.type === 5) {
      local.valueList = local.optionName.split("|").map(el => {
        return el.split(":")[0]
      })
      local.colorList = local.optionName.split("|").map(el => {
        return el.split(":")[1]
      })
    }
    if (local.type === 4) {
      switch (local.default) {
        // 今天
        case 1:
          local.fieldValue = utils.getDateStr(new Date(), 'YYYY-MM-DD hh:mm:ss');
          break;
          // 下一天
        case 2:
          local.fieldValue = utils.getDateStr(new Date(new Date().getTime() + 86400000), 'YYYY-MM-DD hh:mm:ss');
          break;
          // 指定日期
        case 3:
          local.fieldValue = local.assignDate
          break;
      }
    }
    // 如果当前是消息通知类型字段，则需要从 info
    if (local.type === 10) {
      local.extendInfo = {
        sms: {},
        appMsg: {},
        wxMsg: {}
      };
      let messageInfos = (list[1] || '').split('|');
      messageInfos.forEach((item) => {
        let messageInfo = item.split('-');
        switch (messageInfo[0]) {
          case '3':
            local.extendInfo.sms = {
              checked: true,
              messageModel: messageInfo[1],
              messageContent: messageInfo[2]
            };
            break;
          case '4':
            local.extendInfo.wxMsg = {
              checked: true,
              messageModel: messageInfo[1],
              messageContent: messageInfo[2]
            };
            break;
          case '5':
            local.extendInfo.appMsg = {
              checked: true,
              messageModel: messageInfo[1],
              messageContent: messageInfo[2]
            };
            break;
        }
      })
    }
    if (target.fieldCode) {
      local.fieldCode = target.fieldCode
    }
    return local
  },
  encryptStr(str = '') {
    if (str.length === 2) {
      // 两个字，隐藏第二个字符
      str = utils.replaceStar(str, 1);
    } else if (str.length === 11) {
      // 手机号，隐藏中间4个数字
      str = utils.replaceStar(str, 3, 7);
    } else if (str.length === 18) {
      // 身份证号，隐藏出生年月日信息
      str = utils.replaceStar(str, 6, 14);
    } else {
      // 其他长度，三等分，隐藏中间信息
      let showLength = Math.round(str.length / 3);
      str = utils.replaceStar(str, showLength, str.length - showLength);
    }
    return str;
  },
  replaceStar(str = '', startIndex = 0, endIndex = 0) {
    if (!str || !str.length) {
      return '';
    }
    if (str.length <= startIndex) {
      return str;
    }
    if (startIndex > endIndex || endIndex > str.length) {
      endIndex = str.length;
    }
    let starts = (new Array(endIndex - startIndex + 1)).join('*');
    return str.substring(0, startIndex) + starts + str.substring(endIndex, str.length)
  }
}

export default utils